import React from "react";
import "./style.css";

export const CourseReview = ({
  name,
  instagram,
  avatar,
  points,
  text,
  highlighted = false,
  language
}) => {

  const translations = {
    "more": {
      "en": "View more",
      "es": "Ver más",
      "pt": "Ver mais",
      "fr": "Voir plus",
      "ru": "Читать далее"
    },
    "less": {
      "en": "View less",
      "es": "Ver menos",
      "pt": "Ver menos",
      "fr": "Voir moins",
      "ru": "Скрыть"
    },
    "verified_user": {
      "en": "Verified user",
      "es": "Usuario verificado",
      "pt": "Utilizador verificado",
      "fr": "Utilisateur vérifié",
      "ru": "Проверенный пользователь"
    }
  };

  const max_comment_length = highlighted ? 350 : 300;

  const [text_expanded, setExpanded] = React.useState(text.length <= max_comment_length);

  return (

    <div className={`${highlighted ? 'course_review_div_highlight' : 'course_review_div'}`}>
      <div className={highlighted ? 'course_review_div_inner' : ''}>
        <div itemProp="aggregateRating" itemType="http://schema.org/AggregateRating"></div>

        <div className="course_review_header">
          <div className="course_review_avatar" style={{ "backgroundImage": `url('${avatar}')` }}></div>
          <div className="course_review_name">{name}
            <br />
            <span className="instagram_user_text">{(instagram == "" || instagram[0] == "@") ? instagram : ('@' + instagram)}</span>
            <br />
            <span className="verified_user_text">{translations["verified_user"][language]}</span>
          </div>
        </div>

        <div className="course_review_stars">
          <span>
            {
              [...Array(points)].map((e, i) =>
                <i key={i} className="review_icon_star">
                  <svg width="18px" height="18px" viewBox="0 0 16 16" className="bi bi-star-fill" fill="#EBB017" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
                  </svg>
                </i>
              )
            }
          </span>
        </div>

        <div className={`course_review_text ${highlighted ? 'mt-3' : ''}`}>
          {
            text_expanded ? text : text.substr(0, max_comment_length - 50) + '...'
          }
        </div>

        {
          text_expanded ?
            (text.length > max_comment_length) ?
              <div className="course_review_view_more" onClick={() => setExpanded(false)}>{translations["less"][language]}</div>
              :
              <></>
            :
            !highlighted ?
              <div className="course_review_view_more" onClick={() => setExpanded(true)}>{translations["more"][language]}</div>
              :
              <></>
        }
      </div>
    </div>

  );
};